module.exports = __webpack_public_path__ + "img/ic_menu_hidemenu.61cf0060.svg";